<template>
  <section-layout
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.incidenciasVencidas}}
    </template>
    <template v-slot:content>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-medium-title class="pr-5">
              {{localization.filtros.title}}
            </o-medium-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <filtrosIncidencias
              tipo="incidenciasVencidas"
              :disabled="loading"
              @aplicar="aplicarFiltros"
              @borrar="borrarFiltros"
              @exportar="exportarExcel"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card class="mt-4">
        <v-container fluid>
          <v-data-table :headers="headers" :items="incidencias"
            :search="tableSearch" :loading="loading"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, -1],
              'items-per-page-text': $t('filasPorPagina'),
            }">
            <template v-slot:top>
              <v-row no-gutters justify="end" align="center">
                <v-col cols="4">
                  <v-text-field
                    v-model="tableSearch" id="tableSearch"
                    :label="localization.filtros.buscar" prepend-icon="search"
                  />
                </v-col>
              </v-row>
            </template>
            <template
              v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.incidenciaId">
                  <!--<td>{{ item.incidenciaId }}</td>-->
                  <td>{{ item.referencia }}</td>
                  <td>{{ traduccionTipoSolicitud(item) }}</td>
                  <td>{{ item.nombreResponsable }}</td>
                  <td>{{ item.desc_delegacion }}</td>
                  <td>{{ item.propertyDevelopment }}</td>
                  <td>{{ item.provincia }}</td>
                  <td>{{ item.sector }}</td>
                  <td>{{ item.uhedit }}</td>
                  <td v-html="item.location"></td>
                  <td>{{ item.poblacion }}</td>
                  <td v-if="idubapi.motor !== 'SIN_BD'">{{ item.valorCP }}</td>
                  <td>{{ traduccionLocalizacion(item) }}</td>
                  <td>{{ item.description.substring(0, 60) + '...' }}</td>
                  <td>{{ traduccionOficio(item) }}</td>
                  <td>{{ traduccionEstado(item) }}</td>
                  <td>{{ traduccionUrgencia(item) }}</td>
                  <td>{{ item.codigoProveedor }}</td>
                  <td>{{ item.proveedor }}</td>
                  <td>{{ item.fechaEnvioParte }}</td>
                  <td>{{ item.finishDate }}</td>
                  <td>{{ item.fechaFinalizacion }}</td>
                  <td v-if="idubapi.motor !== 'SIN_BD'">{{ item.fechaEscrituracion }}</td>
                  <td>{{ item.fechaEstado }}</td>
                  <td>{{ item.fechaReapertura }}</td>
                  <td>{{ item.incidenciaPredefinida }}</td>
                  <td>{{ item.origen }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </template>
  </section-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import filtrosIncidencias from './filtrosIncidencias'
import mixinExcel from '@/mixins/downloadExcel'

export default {
  mixins: [mixinExcel],
  components: {
    filtrosIncidencias
  },
  data () {
    return {
      loading: false,
      tableSearch: '',
      incidencias: []
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localization () {
      return this.$t('sectionInformes')
    },
    headers () {
      let headerEscrituracion = this.idubapi.motor !== 'SIN_BD' ? [{ text: this.localization.incidenciasVencidas.fechaEscrituracion, value: 'fechaEscrituracion' }] : []
      let headerValorCP = this.idubapi.motor !== 'SIN_BD' ? [{ text: this.localization.incidenciasVencidas.valorCP, value: 'valorCP' }] : []
      return [
        { text: this.localization.incidenciasVencidas.referencia, value: 'incidenciaId' },
        { text: this.localization.incidenciasVencidas.tipoSolicitud, value: 'tipoSolicitud' },
        { text: this.localization.estadisticas.responsable, value: 'nombreResponsable' },
        { text: this.localization.incidenciasVencidas.delegacion, value: 'desc_delegacion' },
        { text: this.localization.incidenciasVencidas.promocion, value: 'propertyDevelopment' },
        { text: this.localization.incidenciasVencidas.provincia, value: 'provincia' },
        { text: this.localization.incidenciasVencidas.sector, value: 'sector' },
        { text: this.localization.incidenciasVencidas.idInmueble, value: 'idInmueble' },
        { text: this.localization.incidenciasVencidas.ubicacion, value: 'location' },
        { text: this.localization.incidenciasVencidas.poblacion, value: 'poblacion' },
        ...headerValorCP,
        { text: this.localization.incidenciasVencidas.localizacion, value: 'room' },
        { text: this.localization.incidenciasVencidas.descripcion, value: 'description' },
        { text: this.localization.incidenciasVencidas.oficio, value: 'profession' },
        { text: this.localization.incidenciasVencidas.estado, value: 'state' },
        { text: this.localization.incidenciasVencidas.urgencia, value: 'urgencia' },
        { text: this.localization.incidenciasVencidas.codigoProveedor, value: 'codigoProveedor' },
        { text: this.localization.incidenciasVencidas.proveedor, value: 'proveedor' },
        { text: this.localization.incidenciasVencidas.envioParte, value: 'fechaEnvioParte' },
        { text: this.localization.incidenciasVencidas.fechaFinPrevista, value: 'finishDate' },
        { text: this.localization.incidenciasVencidas.fechaFinalizacion, value: 'fechaFinalizacion' },
        ...headerEscrituracion,
        { text: this.localization.incidenciasVencidas.fechaEstado, value: 'fechaEstado' },
        { text: this.localization.incidenciasVencidas.fechaReapertura, value: 'fechaReapertura' },
        { text: this.localization.incidenciasVencidas.incidenciaPredefinida, value: 'incidenciaPredefinida' },
        { text: this.localization.incidenciasVencidas.origen, value: 'origen' }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getIncidencias: 'informes/getIncidencias'
    }),
    async aplicarFiltros (values) {
      try {
        this.loading = true
        var respuesta = await this.getIncidencias(values)
        this.incidencias = respuesta.data
      } catch (error) {
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    borrarFiltros () {
      this.incidencias = []
    },
    async exportarExcel (values) {
      try {
        this.loading = true
        let file = await this.getIncidencias(values)
        this.downloadExcel(file.file || file.data)
      } catch (error) {
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    traduccionTipoSolicitud (item) {
      if(this.usuario.idioma === 'spa') {
        return item.tipoSolicitud
      } else {
        let tradTipoSolicitud = JSON.parse(item.traduccionTipoSolicitud)
        if(tradTipoSolicitud) {
          return tradTipoSolicitud[this.usuario.idioma] || item.tipoSolicitud
        } else {
          return item.tipoSolicitud
        }
      }
      
    },
    traduccionLocalizacion (item) {
      if(this.usuario.idioma === 'spa') {
        return item.room
      } else {
        let tradRoom = JSON.parse(item.traduccionEstancia)
        if(tradRoom) {
          return tradRoom[this.usuario.idioma] || item.room
        } else {
          return item.room
        }
        
      }
    },
    traduccionOficio (item) {
      if(this.usuario.idioma === 'spa') {
        return item.profession
      } else {
        let tradOficio = JSON.parse(item.traduccionOficio)
        if(tradOficio) {
          return tradOficio[this.usuario.idioma] || item.profession
        } else {
          return item.profession
        }
        
      }
    },
    traduccionUrgencia (item) {
      if(this.usuario.idioma === 'spa') {
        return item.urgencia
      } else {
        let tradUrgencia = JSON.parse(item.traduccionUrgencia)
        if(tradUrgencia) {
          return tradUrgencia[this.usuario.idioma] || item.urgencia
        } else {
          return item.urgencia
        }
        
      }
    },
    traduccionEstado (item) {
      if(this.usuario.idioma === 'spa') {
        return item.state
      } else {
        let tradEstado = JSON.parse(item.traduccionEstado)
        if(tradEstado) {
          return tradEstado[this.usuario.idioma] || item.state
        } else {
          return item.state
        } 
      }
    }
  }
}
</script>
